"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useIsMobile } from "@/hooks/use-mobile";
import { WritingTools } from "./writing-tools";

/** Desktop toolbar entry; mobile owns its entry in the bottom navigation. */
export function EditorDesktopWritingTools() {
  const $ = _c(1);
  const pathname = usePathname();
  const isMobile = useIsMobile();
  if (isMobile || !/\/editor\/[^/]+\/chapters\/[^/]+/.test(pathname)) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WritingTools />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}